var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: [
        _vm.bemBlock,
        "base-actionable-link",
        {
          "visually-hidden": _vm.visuallyHidden
        }
      ],
      style: _vm.cssCustomProps,
      on: {
        click: function($event) {
          return _vm.$emit("actionable-link:clicked")
        }
      }
    },
    [
      _vm.buttonImage
        ? _c("img", {
            class: [
              _vm.bemElement("image"),
              {
                loading: _vm.loadingImage
              }
            ],
            attrs: {
              alt: _vm.$msg(
                "actionable.link.img.alt",
                "product",
                _vm.product.name
              ),
              src: _vm.buttonImage
            },
            on: { error: _vm.handleImageError, load: _vm.isImageLoaded }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.buttonText
        ? _c("span", { class: _vm.bemElement("text") }, [
            _vm._v("\n    " + _vm._s(_vm.buttonText) + "\n  ")
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }